module.exports = __webpack_public_path__ + "img/user-icon-lg.a915773a.png";